import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {LoginDialogComponent} from '../login-dialog/login-dialog.component';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {UserModel} from '../../models/user/user.model';
import {Subject, takeUntil} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
  selector: 'app-navigation',
    imports: [
        NgClass,
        RouterLink,
        RouterLinkActive,
        NgIf,
    ],
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    @Input() branding: string = '';

    mobileOpen: boolean = false
    loggedInUser: UserModel = {
        email: '',
        firstName: '',
        id: '',
        lastName: '',
        mobileNumber: '',
        phoneNumber: '',
        role: '',
        skype: '',
        title: ''
    };

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private breakPointObserver: BreakpointObserver
    ) {
        this.breakPointObserver.observe(['(min-width: 1024px)']).subscribe( result => {
            if (result.matches) {
                this.mobileOpen = false;
            }
        })
    }

    ngOnInit(): void {
        this.loggedInUser = this.authenticationService.getUser();

        this.authenticationService.userSubject.subscribe((user: UserModel) => {
            this.loggedInUser = user;
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    logout(): void {
        this.authenticationService.logout()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: value => {
                    this.router.navigateByUrl('anmeldung')
                },
                error: err => {
                    console.log('error', err);
                }
            })
    }

    toggleMobileMenu(): void {
        this.mobileOpen = !this.mobileOpen
    }
}
